import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { MealNutritionProgress } from "../../../../service/model/nutrition.model";

interface NutritionMemberViewTableProps {
    meal: MealNutritionProgress;
    day: string;
    handleSelect: (mealIndex: number, mealItemIndex: number, mealItemId: number, checked: boolean) => void;
}

const NutritionMemberViewTable = ({ meal, day, handleSelect }: NutritionMemberViewTableProps) => {
    return (
        <TableContainer>
            <h3 style={{ justifySelf: "center" }}>
                {meal.mealTime}
            </h3>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Food Item</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Calories (cal)</TableCell>
                        <TableCell>Protein (g)</TableCell>
                        <TableCell>Carbs (g)</TableCell>
                        <TableCell>Fat (g)</TableCell>
                        <TableCell>Fiber (g)</TableCell>
                        <TableCell>Sugar (g)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {meal.items.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={item.completed}
                                    disabled={dayjs(day).isAfter(dayjs())}
                                    onChange={() => handleSelect(meal.index, index, item.mealItemSnapshot.mealItemId, !item.completed)}
                                />
                            </TableCell>
                            <TableCell>{item.mealItemSnapshot.name}</TableCell>
                            <TableCell>{item.mealItemSnapshot.quantity} {item.mealItemSnapshot.unitSymbol}</TableCell>
                            <TableCell>{item.mealItemSnapshot.nutrition.calories}</TableCell>
                            <TableCell>{item.mealItemSnapshot.nutrition.protein}</TableCell>
                            <TableCell>{item.mealItemSnapshot.nutrition.carbohydrates}</TableCell>
                            <TableCell>{item.mealItemSnapshot.nutrition.fat}</TableCell>
                            <TableCell>{item.mealItemSnapshot.nutrition.fiber}</TableCell>
                            <TableCell>{item.mealItemSnapshot.nutrition.sugar}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default NutritionMemberViewTable;